import { resourceType } from 'constants/loading';
import { findResource } from 'loading/finders';
import { canProxy } from 'user/selectors';
import { getActiveUserId } from 'current/selectors';
import { getAllFarms } from 'farms/selectors';
import { isAppMode } from 'settings/selectors';

import { fetchOwnedFarms, fetchSharedFarms } from 'farms/loaders';
import { parseAllFarms } from 'farms/homesteadParser';
import { processAllFarms } from 'farms/processors';

export const findAllFarms = ({ dispatch, getState, forceReload=false, forceWait=false, onError }) => {
  return Promise.resolve()
  .then( () => {
    const state = getState();
    const userId = getActiveUserId(state);
    let fetchFarms;
    // if app mode, the user will not be proxying, so they can always request anything accessible to them
    if (isAppMode(state)) {
      fetchFarms = fetchSharedFarms;
    } else {
      fetchFarms = canProxy(state) ? fetchOwnedFarms : fetchSharedFarms;
    }
    const resourceSpec = {
      type: resourceType.FARMS,
      selector: () => getAllFarms(getState()),
      fetcher: () => fetchFarms({ userId }),
      processor: ( raw ) => processAllFarms({ dispatch, getState, farms: parseAllFarms( raw ) })
    };
    return findResource({ dispatch, getState, forceReload, forceWait, onError, ...resourceSpec });
  });
};
